// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zEOr","colBig":"styles_colBig__1eZb6","colSmall":"styles_colSmall__1nl-8"};